import useVerifyInviteCode from '../../hooks/event-hooks/verify-invite-code/useVerifyInviteCode';
import AuthVerification from '../../animation/AuthVerification'
import NotFound from '../404/NotFound';

function VerifyInviteCode() {
    const { loading, error } = useVerifyInviteCode();

    if (loading) {
        return (
            <AuthVerification
                message="Verifying Invite Code..."
                subMessage='Please wait while we verify your invite code.'
            />
        )
    }

    if (error) {
        switch (error?.code) {
            case 403:
                return (
                    <NotFound
                        statusCode={error?.code}
                        pageTitle='Access Denied'
                        description='The link that you are trying to access is invalid or expired'
                    />
                );
            case 404:
                return (
                    <NotFound
                        statusCode={error?.code}
                        pageTitle='Not Found'
                        description='The link that you are trying to access is invalid or removed from the server.'
                    />
                );
            default:
                return (
                    <NotFound
                        statusCode={error?.code}
                        pageTitle={error?.message}
                        description="An error occurred while verifying your invite code. Please check the code and try again."
                    />
                );
        }
    }
}

export default VerifyInviteCode